export default "__VITE_ASSET__8eb23d0e__"